import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C10.8954 22 10 21.1046 10 20H14C14 21.1046 13.1046 22 12 22ZM20 19H4V17L6 16V10.5C5.94732 9.0891 6.26594 7.68911 6.924 6.43998C7.57904 5.2815 8.6987 4.45886 10 4.17998V1.99998H13.646C12.3464 3.45242 12.1295 5.57638 13.1087 7.26153C14.0879 8.94667 16.0406 9.80992 17.946 9.39998C17.981 9.75698 17.998 10.127 17.998 10.5V16L19.998 17V19H20ZM17 7.99998C15.4097 7.99752 14.0977 6.75453 14.0093 5.16671C13.9209 3.57888 15.0869 2.19797 16.6671 2.01904C18.2473 1.8401 19.6926 2.92533 19.9615 4.49271C20.2304 6.0601 19.2295 7.56499 17.68 7.92298C17.457 7.97421 17.2288 8.00004 17 7.99998Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "NotificationDot"
);
